var _excluded = ["size", "textAlign", "isSticky", "sortDirection"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { forwardRef } from '../../../../../utils';
import { useStyleConfig } from '../../../../../utils/use-style-config';
import { Box } from '../../../Box';
import { _useTableContext as useTableContext } from '../../_TableContext';
import { _useCellSize as useCellSize } from '../../_useCellSize';
import { jsx as _jsx } from "react/jsx-runtime";
var ariaSortBySortDirection = {
  asc: 'ascending',
  desc: 'descending'
};
/**
 * @private This is for internal use only.
 */

export var _TableHeaderBaseCell = forwardRef((_ref, propRef) => {
  var {
    size,
    textAlign,
    isSticky,
    sortDirection
  } = _ref,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);
  useImperativeHandle(propRef, () => ref.current);
  var [offsetLeft, setOffsetLeft] = useState(0);
  useEffect(() => {
    var _ref$current$offsetLe, _ref$current;

    setOffsetLeft((_ref$current$offsetLe = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.offsetLeft) !== null && _ref$current$offsetLe !== void 0 ? _ref$current$offsetLe : 0);
  }, []);
  var {
    headerVariant
  } = useTableContext();
  var style = useStyleConfig('_TableHeaderBaseCell', {
    size: useCellSize(size),
    textAlign,
    variant: headerVariant,
    isSticky,
    left: offsetLeft
  });
  var ariaSort = sortDirection ? ariaSortBySortDirection[sortDirection] : undefined; // For a11y - table header can't be empty
  // The closest reference is table with two headers
  // https://www.w3.org/WAI/tutorials/tables/two-headers/

  var role = restProps.children ? 'columnheader' : 'cell';
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    role: role,
    __css: style,
    "data-component": "TableHeaderBaseCell",
    "aria-sort": ariaSort
  }, restProps), {}, {
    ref: ref
  }));
});
_TableHeaderBaseCell.displayName = 'TableHeaderBaseCell';
//# sourceMappingURL=_TableHeaderBaseCell.js.map